import BaseError from "./BaseError";

export default class NotFoundError extends BaseError {
  constructor(message: string, info?: any, cause?: Error) {
    super({
      statusCode: 404,
      message,
      info: info || null,
      cause,
    });
    this.name = "NotFoundError";
  }
}
